<template>
  <section id="restaurant" class="slideDown">
    <div class="container">
      <div class="content">
        <div class="back" @click="back()">
          {{ $t('admin.restaurant.back') }}
        </div>

        <h3 class="title">
          <span v-if="restaurant.id == -1">{{ $t('general.create') }}</span><span v-else>{{ $t('general.edit') }}</span
          ><span>{{ $t('admin.restaurant.restaurant') }}</span>
        </h3>

        <div class="details">
          <div class="subtitle">{{ $t('general.subtitle') }}</div>
          <div class="subtitle" v-if="restaurant_log" v-html="$t('admin.restaurant.last_modification', { user: restaurant_log.user, date: restaurant_log.date })"></div>
          <v-form ref="form_restaurant" v-model="valid">
            <v-container grid-list-xl>
              <v-layout row>
                <v-flex xs6>
                  <v-text-field
                    v-model="restaurant.site"
                    :rules="requiredRules"
                    :label="$t('admin.restaurant.site')"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="restaurant.name"
                    :rules="requiredRules"
                    :label="$t('admin.restaurant.name')"
                    required
                  ></v-text-field>
                  <v-select
                    v-model="restaurant.province_id"
                    :rules="requiredRules"
                    :items="provinces"
                    :label="$t('admin.restaurant.province')"
                  ></v-select>
                  <v-text-field
                    v-model="restaurant.cif"
                    :label="$t('admin.restaurant.cif')"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="restaurant.razon"
                    :label="$t('admin.restaurant.razon')"
                    required
                  ></v-text-field>
                  <v-select
                    v-model="restaurant.region"
                    :rules="requiredRules"
                    :items="regions"
                    :label="$t('general.region')"
                  ></v-select>
                  <v-select
                    v-model="restaurant.type"
                    :rules="requiredRules"
                    :items="types"
                    :label="$t('general.restaurant_mode')"
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="restaurant.email"
                    :label="$t('general.email')"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="restaurant.address"
                    :rules="requiredRules"
                    :label="$t('admin.restaurant.direction')"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="restaurant.city"
                    :label="$t('admin.restaurant.city')"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="restaurant.cp"
                    :label="$t('admin.restaurant.cp')"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="restaurant.latitud"
                    :label="$t('admin.restaurant.latitude')"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="restaurant.longitud"
                    :label="$t('admin.restaurant.longitude')"
                    required
                  ></v-text-field>
                  <v-switch
                    v-model="restaurant.active"
                    :label="$t('admin.restaurant.active')"
                    @change="onActiveChange"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <div class="subtitle">{{ $t('general.pyp') }}</div>
          <v-form ref="form_pyp" v-model="valid">
            <v-container grid-list-xl>
              <v-layout row>
                <v-flex xs6>
                  <v-switch
                    v-if="market == 'ES'"
                    :key="restaurant.mop_service"
                    v-model="restaurant.mop_service"
                    :label="$t('admin.restaurant.mop_service')"
                    :value="restaurant.mop_service"
                    :true-value="
                      restaurant.mop_service == true ||
                      restaurant.mop_service == 'true'
                        ? true
                        : false
                    "
                  ></v-switch>
                  <span
                    v-if="market == 'ES' && restaurant.mop_status != '-' && restaurant.mop_service"
                    class="v-label"
                  >
                    {{ $t('general.headers.mop_status') }}: {{ restaurant.mop_status }}
                  </span>
                </v-flex>
                <v-flex xs6>
                  <v-switch
                    v-if="market == 'ES'"
                    v-model="restaurant.my_order"
                    :label="$t('admin.restaurant.my_order')"
                    :disabled="isRestaurantActive"
                    :hint="isRestaurantActive ? $t('admin.restaurant.my_order_disabled_hint') : ''"
                    persistent-hint
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </div>

        <div class="buttons">
          <v-btn large color="success" @click="save()">{{ $t('general.save') }}</v-btn>
          <v-btn large color="cancel" @click="back()">{{ $t('general.back') }}</v-btn>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import i18n from "@/i18n";
export default {
  props: {},
  data() {
    return {
      restaurant: JSON.parse(
        JSON.stringify(this.$store.getters["locations/getRestaurantSelected"])
      ),
      delivery: [
        this.$t("admin.restaurant.delivery.no_delivery"),
        this.$t("admin.restaurant.delivery.uber"),
        this.$t("admin.restaurant.delivery.glovo")
      ],
      emailRules: [
        v => !!v || i18n.t("general.obligatory_email"),
        v =>
          new RegExp(
            "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@es.mcd.com"
          ).test(v) || i18n.t("general.obligatory_email_domain")
      ],
      requiredRules: [v => !!v || i18n.t("general.obligatory_field")],
      valid: false,
      restaurant_log: null
    };
  },
  created() {
    var id = this.restaurant.id != -1 ? this.restaurant.id : "add";
    this.$router.push({ name: "restaurants_edit", params: { id: id } });

    this.restaurant.active = this.restaurant.active == "1";
    this.normalizeMyOrder();
  },
  computed: {
    market() {
      return this.$store.getters["getMarket"];
    },
    isRestaurantActive() {
      return (
        this.restaurant.active === true ||
        this.restaurant.active === "true" ||
        this.restaurant.active === 1 ||
        this.restaurant.active === "1"
      );
    },
    regions() {
      var regions = ObjectToArray(this.$store.getters["locations/getRegions"]);
      var aRegions = [];
      regions.forEach(region => {
        aRegions.push({ text: region.name, value: region.id });
      });

      return aRegions;
    },
    types() {
      var types = ObjectToArray(this.$store.getters["locations/getTypes"]);
      var aTypes = [];
      types.forEach(type => {
        aTypes.push({ text: type.name, value: type.id });
      });

      return aTypes;
    },
    provinces() {
      var provinces = ObjectToArray(
        this.$store.getters["locations/getProvinces"]
      );
      var aProvinces = [];
      provinces.forEach(province => {
        province.code != "00"
          ? aProvinces.push({ text: province.name, value: province.id })
          : true;
      });

      return aProvinces;
    }
  },
  methods: {
    back() {
      this.$store.commit("locations/setSelectedRestaurant", false);
      this.$router.push({ name: "restaurants" });
    },
    normalizeMyOrder() {
      if (this.isRestaurantActive) {
        this.restaurant.my_order = false;
        return;
      }

      this.restaurant.my_order =
        this.restaurant.my_order === true ||
        this.restaurant.my_order === "true" ||
        this.restaurant.my_order === 1 ||
        this.restaurant.my_order === "1";
    },
    onActiveChange() {
      this.normalizeMyOrder();
    },
    save() {
      if (this.$refs.form_restaurant.validate()) {
        this.normalizeMyOrder();
        var self = this;
        this.$store
          .dispatch("locations/uploadRestaurant", this.restaurant)
          .then(function() {
            self.$store.commit("locations/setSelectedRestaurant", false);
            self.$router.push({ name: "restaurants" });
          });
      }
    }
  },
  async mounted() {
    this.restaurant_log = await this.$store.dispatch("locations/getRestaurantLog", this.restaurant.id);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.back {
  background: url(/img/left-arrow.svg) no-repeat left center;
  text-align: left;
  margin-bottom: 40px;
  padding-left: 25px;
  cursor: pointer;
}
.container {
  width: 100%;
  overflow: hidden;

  .content {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
    text-align: left;
    padding: 0 25px;

    .title {
      margin: 10px 0;
      font-size: 20pt;
      font-family: Speedee-Bold !important;
    }
    .subtitle {
      margin-bottom: 25px;
      color: #888;
    }

    .buttons {
      margin: 35px 0;
      text-align: center;

      .bttn {
        width: 100%;
        max-width: 300px;
        overflow: hidden;
        margin-bottom: 5px;
        line-height: 30px;
        cursor: pointer;
        display: block;
        color: #333;
      }
    }
  }
}
</style>
